import axios from "axios";
import {config} from "../../../config/config";

const apiIntegrations = axios.create({
    baseURL: config.API_INTEGRACIONES_COMUNIDADTASK_URI,
    headers: {
        "Accept": 'application/json',
        "Content-type": "application/json; charset=utf-8",
        "server": "prd",
        "Authorization": "6HrfHg8Z2TT9wT9FKQu4"
    },
})

export const SmuTrackingService  = {
    getOrder: async (orderNro: string) => {
        try {
            const response = await apiIntegrations.get(`/clients/smu/order/${orderNro}`);

            const dataRaw = response.data.order;

            return {
                success: true,
                data: dataRaw
            }
        } catch (err: any) {
            return {
                success: false,
                error: err
            }
        }
    }
};